/**
 * useDatabaseConnectionDetails Hook
 *
 * Custom React Query hook for fetching a single database connection's details.
 */

import { useQuery } from '@tanstack/react-query';
import { databaseConnectionService } from '../../../api/database-connection.service';

/**
 * Hook for fetching database connection details
 * @param tenantId - Tenant ID
 * @param dbConnectionId - Database Connection ID
 */
export const useDatabaseConnectionDetails = (tenantId: string, dbConnectionId: string | null) => {
  return useQuery({
    queryKey: ['database-connections', tenantId, dbConnectionId],
    queryFn: async () => {
      if (!dbConnectionId) return null;
      return databaseConnectionService.getDatabaseConnection(tenantId, dbConnectionId);
    },
    enabled: !!tenantId && !!dbConnectionId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
